import React from "react"
import InputRange from "react-input-range"
import SearchResultContentStyle from "./SearchResultContentStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const SearchResultContent = ({
  glPerServe,
  value,
  newFood,
  handleInputValueChange,
  searchWord,
  locale,
}) => {
  return (
    <div>
      {searchWord === newFood.name ? (
        <div>
          <div className={SearchResultContentStyle.content_info_holder}>
            <div className={SearchResultContentStyle.GI_holder}>
              <p className={SearchResultContentStyle.GI_name}>
                {translate(keys.GLYCEMIC_INDEX_OF, locale)} {newFood.name}{" "}
              </p>
              <p className={SearchResultContentStyle.GI_amount}>
                {newFood.giMean}
              </p>
            </div>

            <div className={SearchResultContentStyle.GL_holder}>
              <p className={SearchResultContentStyle.GL_name}>
                {translate(keys.GLYCEMIC_LOAD_OF, locale)} {newFood.name}{" "}
                {translate(keys.PER_SERVING_OF, locale)}{" "}
                {value === "" ? 0 : value} {translate(keys.GRAM, locale)}
              </p>
              <p className={SearchResultContentStyle.GL_amount}>
                {glPerServe === "NaN" ? 0 : glPerServe}
              </p>
            </div>
          </div>

          <div className="search-result-slider-holder">
            <InputRange
              maxValue={500}
              minValue={0}
              formatLabel={value => `${value} ${translate(keys.GRAM, locale)}`}
              onChange={value => handleInputValueChange("", value)}
              value={value}
            />
            <input
              type="number"
              name="max"
              onChange={handleInputValueChange}
              className={SearchResultContentStyle.max_value}
              value={value}
            />
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default SearchResultContent
